"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssignRule = void 0;
const vue_1 = require("vue");
const complex_data_1 = require("complex-data");
const ListView_1 = __importDefault(require("@/components/data/ListView"));
const plugin_1 = require("@/plugin");
const system_1 = __importDefault(require("@/pages/index/api/system"));
const config_1 = require("@/config/dictionary/config");
const location_1 = require("@/pages/index/select/location");
const select_1 = require("@/pages/index/select");
class AssignRule extends complex_data_1.ComplexList {
    buildItem(postData) {
        return new Promise((resolve, reject) => {
            system_1.default.areaBuild.require(postData).then(() => {
                select_1.areaRegion.$loadData(true);
                this.$reloadData({
                    force: true
                }).finally(() => {
                    resolve({ status: 'success' });
                });
            }).catch(err => {
                // eslint-disable-next-line no-console
                console.error(err);
                reject(err);
            });
        });
    }
    changeItem(postData, originData) {
        return new Promise((resolve, reject) => {
            postData.id = originData.id;
            system_1.default.areaChange.require(postData).then(() => {
                select_1.areaRegion.$loadData(true);
                this.$reloadData({
                    force: true
                }).finally(() => {
                    resolve({ status: 'success' });
                });
            }).catch(err => {
                // eslint-disable-next-line no-console
                console.error(err);
                reject(err);
            });
        });
    }
    deleteItem() {
        return new Promise((resolve, reject) => {
            system_1.default.areaDelete.require(this.$module.choice.getId()).then(() => {
                select_1.areaRegion.$loadData(true);
                this.$module.choice.$reset();
                this.$reloadData({
                    force: true
                }).finally(() => {
                    resolve({ status: 'success' });
                });
            }).catch(err => {
                // eslint-disable-next-line no-console
                console.error(err);
                reject(err);
            });
        });
    }
}
exports.AssignRule = AssignRule;
exports.default = (0, vue_1.defineComponent)({
    name: 'AreaHome',
    components: {
        ListView: ListView_1.default
    },
    data() {
        const mainData = new AssignRule({
            name: '区域管理',
            prop: 'areaData',
            module: {
                pagination: true,
                choice: {},
                search: {
                    module: {
                        dictionary: {
                            layout: {
                                default: {
                                    grid: 8,
                                    label: 8,
                                    content: 16
                                }
                            },
                            list: [
                                {
                                    prop: 'areaName',
                                    name: '区域名称',
                                    originProp: 'areaName',
                                    mod: {
                                        search: {
                                            $type: 'edit'
                                        }
                                    }
                                }
                            ]
                        }
                    },
                    menu: {
                        list: []
                    },
                },
                dictionary: {
                    layout: {
                        default: {
                            grid: 24,
                            label: 7,
                            content: 17
                        }
                    },
                    option: {},
                    propData: {
                        id: 'id'
                    },
                    list: [
                        {
                            prop: 'id',
                            name: 'ID',
                            originProp: 'id',
                            originFrom: 'list',
                            mod: {}
                        },
                        {
                            prop: 'code',
                            name: '编号',
                            originProp: 'code',
                            originFrom: 'list',
                            mod: {
                                list: {
                                    width: 140
                                }
                            }
                        },
                        {
                            prop: 'areaName',
                            name: '区域名称',
                            originProp: 'areaName',
                            originFrom: 'list',
                            mod: {
                                list: {
                                    width: 140
                                },
                                edit: {
                                    type: 'input',
                                    required: true,
                                    option: {
                                        size: 40
                                    }
                                },
                                build: {
                                    $target: 'edit'
                                },
                                change: {
                                    $target: 'edit'
                                }
                            }
                        },
                        {
                            prop: 'areaCityNames',
                            name: '所属省市',
                            originProp: 'areaCityNames',
                            originFrom: 'list',
                            mod: {
                                list: {
                                    width: 200
                                }
                            }
                        },
                        {
                            prop: 'areaCityCodes',
                            name: '所属省市',
                            originProp: 'areaCityCodes',
                            originFrom: 'list',
                            format(value) {
                                if (value) {
                                    const valueStrList = value.split(',');
                                    const valueList = [];
                                    valueStrList.forEach(valueStr => {
                                        if (valueStr.indexOf('|') > -1) {
                                            const valueItemList = valueStr.split('|');
                                            valueList.push(valueItemList);
                                        }
                                        else {
                                            valueList.push([valueStr]);
                                        }
                                    });
                                    return valueList;
                                }
                            },
                            edit(value, { targetData, originData }) {
                                targetData.areaCityNames = originData === null || originData === void 0 ? void 0 : originData.areaCityNames;
                                return value;
                            },
                            post(value, { targetData, originData }) {
                                if (value) {
                                    const valuelist = [];
                                    value.forEach(valueItem => {
                                        if (valueItem.length === 1) {
                                            // 省全选，更换为市数据
                                            const provinceValue = location_1.location.getItem(valueItem[0]);
                                            if (provinceValue.children) {
                                                provinceValue.children.forEach(cityValue => {
                                                    valuelist.push(valueItem[0] + '|' + cityValue.value);
                                                });
                                            }
                                            else {
                                                valuelist.push(valueItem[0]);
                                            }
                                        }
                                        else {
                                            valuelist.push(valueItem[0] + '|' + valueItem[1]);
                                        }
                                    });
                                    targetData.areaCityNames = originData.areaCityNames;
                                    return valuelist.join(',');
                                }
                            },
                            mod: {
                                edit: {
                                    type: 'cascader',
                                    required: true,
                                    multiple: true,
                                    option: {
                                        list: location_1.location.getList()
                                    },
                                    local: {
                                        target: {
                                            props: {
                                                multiple: true
                                            }
                                        }
                                    },
                                    on: {
                                        change(valueList, valueItemList, payload) {
                                            const targetData = payload.form.getData();
                                            if (valueItemList) {
                                                targetData.areaCityNames = valueItemList.map(valueItem => {
                                                    return valueItem[valueItem.length - 1].label;
                                                }).join(',');
                                            }
                                            else {
                                                targetData.areaCityNames = undefined;
                                            }
                                        }
                                    }
                                },
                                build: {
                                    $target: 'edit'
                                },
                                change: {
                                    $target: 'edit'
                                }
                            }
                        },
                        {
                            prop: 'remark',
                            name: '备注',
                            originProp: 'remark',
                            originFrom: 'list',
                            mod: {}
                        },
                        {
                            prop: 'createdName',
                            name: '创建人',
                            originProp: 'createdName',
                            originFrom: 'list',
                            mod: {
                                list: {
                                    width: config_1.listWidth.personnelName
                                }
                            }
                        },
                        {
                            prop: 'createdBy',
                            name: '创建人',
                            originProp: 'createdBy',
                            originFrom: 'list'
                        },
                        {
                            prop: 'createdTime',
                            name: '创建时间',
                            originProp: 'createdTime',
                            originFrom: 'list',
                            mod: {
                                list: {
                                    width: config_1.listWidth.time
                                }
                            }
                        },
                        {
                            prop: 'updatedBy',
                            name: '最后更新人',
                            originProp: 'updatedBy',
                            originFrom: 'list',
                            mod: {}
                        },
                        {
                            prop: 'updatedTime',
                            name: '更新时间',
                            originProp: 'updatedTime',
                            originFrom: 'list',
                            mod: {}
                        },
                        {
                            prop: 'menu',
                            name: '操作',
                            originProp: 'menu',
                            originFrom: 'list',
                            mod: {
                                list: {
                                    width: config_1.listWidth.getWidth(2)
                                }
                            }
                        },
                    ]
                }
            },
            $getData() {
                return new Promise((resolve, reject) => {
                    system_1.default.areaList.require(Object.assign(Object.assign({}, this.$getSearch()), { pageNo: this.$getPageData('current'), pageSize: this.$getPageData('size') })).then(res => {
                        this.$formatList(res.data.data, res.data.totalCount);
                        resolve({ status: 'success' });
                    }).catch(err => {
                        // eslint-disable-next-line no-console
                        console.error(err);
                        reject(err);
                    });
                });
            }
        });
        return {
            mainData,
            listOption: {
                table: {
                    optionProps: {
                        bordered: true,
                        scroll: {
                            x: this.getWidth()
                        }
                    }
                },
                search: {
                // layout: 'horizontal'
                },
                searchMenu: [
                    {
                        prop: 'setSearch',
                        name: '查询',
                        type: 'primary'
                    },
                    {
                        prop: 'resetSearch',
                        name: '重置',
                        type: 'default'
                    },
                    {
                        prop: 'build',
                        name: '新增',
                        type: 'primary'
                    },
                    {
                        prop: 'delete',
                        name: '删除',
                        type: 'danger',
                        disabled() {
                            return mainData.$module.choice.getId().length === 0;
                        }
                    }
                ],
                menu: {
                    list: [
                        {
                            prop: 'change',
                            name: '编辑'
                        }
                    ]
                }
            }
        };
    },
    computed: {
        width() {
            return this.getWidth();
        }
    },
    mounted() {
        this.mainData.$loadData(true);
    },
    beforeUnmount() {
        this.mainData.$reset();
    },
    methods: {
        getWidth() {
            return plugin_1.reactiveLayout.data.main.width - 16 * 2;
        }
    }
});
